import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "inline-images"
    }}>{`Inline Images`}</h1>
    <p>{`Add inline images in the document through json data using the <img`}{`>`}{` tag.`}</p>
    <h2 {...{
      "id": "how-it-works"
    }}>{`How It Works`}</h2>
    <p>{`Image url can be provided in the input json data using html img tag. `}</p>
    <p>{`JSON representation of the input data:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "ContentBlock": "sample image - <img src=\\"https://documentcloud.adobe.com/dc-docgen-app/assets/dc_icon.png\\">"
}
`}</code></pre>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "8.124999999999998%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/2f29210f43232c16a87c993292c0736e/5530d/inlineImageJson.webp 320w", "/document-services/docs/static/2f29210f43232c16a87c993292c0736e/0c8fb/inlineImageJson.webp 640w", "/document-services/docs/static/2f29210f43232c16a87c993292c0736e/94b1e/inlineImageJson.webp 1280w", "/document-services/docs/static/2f29210f43232c16a87c993292c0736e/e7fea/inlineImageJson.webp 1648w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/2f29210f43232c16a87c993292c0736e/dd4a7/inlineImageJson.png 320w", "/document-services/docs/static/2f29210f43232c16a87c993292c0736e/0f09e/inlineImageJson.png 640w", "/document-services/docs/static/2f29210f43232c16a87c993292c0736e/bbbf7/inlineImageJson.png 1280w", "/document-services/docs/static/2f29210f43232c16a87c993292c0736e/55862/inlineImageJson.png 1648w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/docs/static/2f29210f43232c16a87c993292c0736e/bbbf7/inlineImageJson.png",
            "alt": "Representation of sample json data",
            "title": "Representation of sample json data",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p>{`In the above example, the tag `}<b>{`ContentBlock`}</b>{` contains an `}<b>{`<img`}{`>`}</b>{` html tag. This image will be downloaded and placed in the final document as shown below.
`}<span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "32.1875%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/f32e1ff1643612af952b565b9dad7616/5530d/inlineImage.webp 320w", "/document-services/docs/static/f32e1ff1643612af952b565b9dad7616/0c8fb/inlineImage.webp 640w", "/document-services/docs/static/f32e1ff1643612af952b565b9dad7616/94b1e/inlineImage.webp 1280w", "/document-services/docs/static/f32e1ff1643612af952b565b9dad7616/fee8c/inlineImage.webp 1362w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/f32e1ff1643612af952b565b9dad7616/dd4a7/inlineImage.png 320w", "/document-services/docs/static/f32e1ff1643612af952b565b9dad7616/0f09e/inlineImage.png 640w", "/document-services/docs/static/f32e1ff1643612af952b565b9dad7616/bbbf7/inlineImage.png 1280w", "/document-services/docs/static/f32e1ff1643612af952b565b9dad7616/7046d/inlineImage.png 1362w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/docs/static/f32e1ff1643612af952b565b9dad7616/bbbf7/inlineImage.png",
            "alt": "Adding inline image in the document through json data using image <img> tag",
            "title": "Adding inline image in the document through json data using image <img> tag",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <b>Note:</b> Only https urls are supported.

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      